import { Component } from '@angular/core';
import { NgFor } from '@angular/common';

type FooterLink = {
  label: string;
  href: string;
};

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [NgFor],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  readonly quickLinks: FooterLink[] = [
    { label: 'Home', href: '#about' },
    { label: 'About Us', href: '#about-us' },
    { label: 'Services', href: '#services' },
    { label: 'FAQ', href: '#faq' },
    { label: 'Contact', href: '#contact' }
  ];

}
